import { camelizeKeys } from "humps";
//
// FIXME: Duplicate with "fetch-run/src/parse-url"
import parseUrl from "./parse-url";

export default function createCamelize(schemas) {
  return next => async req => {
    let json = await next(req);

    const url = parseUrl(req.url);
    const prefix = schemas._prefix ? `/${schemas._prefix}/` : "/";
    const pathname = url.pathname.replace(prefix, "");
    const urls = schemas[req.method.toLowerCase()];
    let found = false;

    for (let pattern in urls) {
      const re = new RegExp(pattern);

      if (re.test(pathname)) {
        found = true;
        break;
      }
    }

    return found ? camelizeKeys(json) : json;
  };
}
